<template>
  <div id="app" :style="layoutStyle">
    <router-view />
  </div>
</template>
<script>
export default {
  data () {
    return {
      layoutStyle: {
        // 颜色
        '--topBar-default-color': process.env.VUE_APP_TopBarBackground // 头部背景颜色
      }
    }
  }
}
</script>
<style lang="less">
html, body, div, p, ul, ol, dl, dd, h1, h2, h3, h4, h5, h6 {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul,ol,menu{
  list-style:none;
}
#app {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  font-size: 14px;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
